export enum CallFailurePhrases {
  endpointNotAvailable = 'endpoint not available',
}
